import { Divider, Stack, Typography } from '@mui/material'

import { FunctionComponent } from 'react'
import { useAuth } from '@frontegg/react'

const UserInfo: FunctionComponent = () => {
  const { user } = useAuth()
  return (
    <>
      {user && (
        <>
          <Stack
            spacing={0.5}
            sx={{
              justifyContent: 'center',
              alignItems: 'flex-start',
              px: 2,
              pt: 1,
              pb: 2
            }}
            data-testid="user-info"
          >
            <Typography>{user.name}</Typography>
            <Typography variant="body2" color="text.secondary">
              {user.email}
            </Typography>
          </Stack>
          <Divider />
        </>
      )}
    </>
  )
}

export default UserInfo
